import { render, staticRenderFns } from "./failure-maintenance.vue?vue&type=template&id=cbce549a&scoped=true"
import script from "./failure-maintenance.vue?vue&type=script&lang=js"
export * from "./failure-maintenance.vue?vue&type=script&lang=js"
import style0 from "./failure-maintenance.vue?vue&type=style&index=0&id=cbce549a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbce549a",
  null
  
)

export default component.exports